import SignBlock from '../../components/bodyBlocks/subscripBlock/SubscripBlock'
import '../../index.css'

function Subscribirse() {
  return (
    <div>
      <SignBlock/>
    </div>
   
  )
}

export default Subscribirse
